<template>
  <div class="row">
    <div class="col-md-12">
      <h4 class="title">Listado de pacientes registrados en el sistema</h4>
      <br />
    </div>
    <div class="col-md-12 card">
      <div class="card-content row">
        <div class="col-sm-6">
          <label for>Cantidad de registros:</label>
          <br />
          <el-select
            class="select-default"
            v-model="pagination.perPage"
            placeholder="Per page"
          >
            <el-option
              class="select-default"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <div class="col-sm-6">
          <div class="pull-right">
            <label>
              <input
                type="search"
                class="form-control"
                placeholder="Buscar paciente..."
                v-model="searchQuery"
              />
            </label>
          </div>
        </div>
        <div class="col-sm-12">
          <br />
          <br />
          <label for="">Ver:</label>
          <select
            @change="cargarPacientes()"
            class="form-control"
            v-model="ver"
          >
            <option :value="1">Activos</option>
            <option :value="0">Inactivos</option>
            <option :value="2">Todos</option>
          </select>
        </div>
        <div class="col-sm-12">
          <div class="row">
            <br />
            <div class="col-md-3">
              <strong style="color: green">Pacientes Activos: {{pacientesActivos}}</strong>
            </div>
            <div class="col-md-3">
              <strong style="color: red">Pacientes Inactivos: {{pacientesInactivos}}</strong>
            </div>
            <div class="col-md-3">
              <strong>Total pacientes: {{totalPacientes}}</strong>
            </div>
            <div class="col-md-3"> <download-excel
                  class="btn pull-right"
                  style="border-radius:0px; color:white; border:green; background-color:#03C639;;"
                  :data="json_data"
                  :fields="json_fields"
                  worksheet="My Worksheet"
                  :name="'Reporte-pacientes'"
                  v-if="json_data!=''"
                >
                Exportar a excel
                </download-excel></div>
          </div>
        </div>
        <div class="col-sm-12">
          <br />
          <el-table
            class="table-striped"
            :data="queriedData"
            border
            style="width: 100%"
          >
            <el-table-column :min-width="60" fixed="left" label="">
              <template slot-scope="props">
                <center>
                  <a
                    class="btn btn-simple btn-info btn-icon like"
                    @click="modalDetallePaciente(props.row)"
                  >
                    <i class="ti-eye"></i>
                  </a>
                </center>
              </template>
            </el-table-column>
            <el-table-column
              v-for="column in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
              else
            ></el-table-column>
            <el-table-column :min-width="60" fixed="right" label="Lideres">
              <template slot-scope="props">
                <center>
                  <a
                    class="btn btn-simple btn-info btn-icon like"
                    @click="modal(props.$index, props.row)"
                  >
                    <i class="ti-user"></i>
                  </a>
                </center>
              </template>
            </el-table-column>
            <el-table-column :min-width="120" fixed="right">
              <template slot-scope="props">
                <br />
                <select
                  :value="props.row.estado"
                  class="form-control select-sm"
                  @change="
                    actualizarEstado(props.row.PacIdeUsu, props.row.estado)
                  "
                >
                  <option value="1">Activo</option>
                  <option value="0">Inactivo</option>
                </select>
                <!-- </center> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <br />
          <p class="category">
            Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
          </p>
        </div>
        <div class="col-sm-6">
          <p-pagination
            class="pull-right"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
          ></p-pagination>
        </div>
      </div>
    </div>
    <modal name="buscar" :scrollable="true" height="auto"  :reset="true">
      <div class="modal-header" style="padding: 8px">
        <div class="row">
          <div class="col-md-1">
            <i class="fa fa-users"></i>
          </div>
          <div class="col-md-7">
            <p class="titulo-modal">ASIGNAR LIDERES TERAPÉUTICOS</p>
            <p class="texto-pequeno">
              Asignación y/o modifiación de lideres terapéuticos
            </p>
          </div>
        </div>
      </div>
      <div class="modal-body" style="padding: 30px; margin:5px;">
        <div class="row" >
          <div class="input-group">
            <span class="input-group-addon">
              <font style="vertical-align: inherit">
                <font style="vertical-align: inherit">Psicología</font>
              </font>
            </span>
            <select name v-model="psico" class="form-control" id>
              <option :value="null">Sin lider</option>
              <!-- <option data-content="<i class='fa fa-cutlery'></i> Cutlery"></option> -->
              <option
                v-for="terapeuta in terapeutasPsico"
                :value="terapeuta.usuario"
                :key="terapeuta.id"
              >
                {{ terapeuta.nombres + " " + terapeuta.apellidos }}
              </option>
            </select>
            <p style="padding-left:5px;" v-if="rol == 1" >Confidencial  <input :disabled="psico==null" v-model="block" type="checkbox"></p>
          </div>
          <div class="input-group">
            <span class="input-group-addon">
              <font style="vertical-align: inherit">
                <font style="vertical-align: inherit">Fisioterapia</font>
              </font>
            </span>
            <select v-model="fisio" class="form-control">
              <option :value="null" >Sin lider</option>
              <option
                v-for="terapeuta in terapeutasFisio"
                :value="terapeuta.usuario"
                :key="terapeuta.id"
              >
                {{ terapeuta.nombres + " " + terapeuta.apellidos }}
              </option>
            </select>
          </div>

          <div class="input-group">
            <span class="input-group-addon">
              <font style="vertical-align: inherit">
                <font style="vertical-align: inherit">Fonoaudiología</font>
              </font>
            </span>
            <select name v-model="fono" class="form-control" id>
              <option :value="null">Sin lider</option>
              <option
                v-for="terapeuta in terapeutasFono"
                :value="terapeuta.usuario"
                :key="terapeuta.id"
              >
                {{ terapeuta.nombres + " " + terapeuta.apellidos }}
              </option>
            </select>
          </div>

          <div class="input-group">
            <span class="input-group-addon">
              <font style="vertical-align: inherit">
                <font style="vertical-align: inherit">Educación especial</font>
              </font>
            </span>
            <select name v-model="edu" class="form-control" id>
              <option :value="null">Sin lider</option>
              <option
                v-for="terapeuta in terapeutasEdu"
                :value="terapeuta.usuario"
                :key="terapeuta.id"
              >
                {{ terapeuta.nombres + " " + terapeuta.apellidos }}
              </option>
            </select>
          </div>
          <div class="input-group">
            <span class="input-group-addon">
              <font style="vertical-align: inherit">
                <font style="vertical-align: inherit">Terapia Ocupacional</font>
              </font>
            </span>
            <select name v-model="teo" class="form-control" id>
              <option :value="null">Sin lider</option>
              <option
                v-for="terapeuta in terapeutasTeo"
                :value="terapeuta.usuario"
                :key="terapeuta.id"
              >
                {{ terapeuta.nombres + " " + terapeuta.apellidos }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn-sm btn-fill btn btn-secondary" style="border-radius:5px;" @click="cerrar_modal()">
          <i class="fa fa-close"></i> Cerrar
        </button>
        <button v-if="rol == 1 || rol == 9 || rol == 13 || rol == 14 || rol == 15" style="border-radius:5px;" class="btn-sm btn-fill btn btn-success" @click="asignar_lideres()">
          <i class="fa fa-send"></i> Actualizar Información
        </button>
      </div>
    </modal>

    <!-- modal detalle de paciente -->
    <modal name="modalDetallePaciente" height="auto" width="800">
      <div class="modal-header" style="padding: 8px">
        <div class="row">
          <div class="col-md-1">
            <i class="fa fa-user"></i>
          </div>
          <div class="col-md-7">
            <p class="titulo-modal">DETALLE DEL PACIENTE</p>
            <p class="texto-pequeno">Información detallada del paciente</p>
          </div>
        </div>
      </div>
      <div class="modal-body" v-if="informacionPaciente != ''">
        <div class="row">
          <div class="col-md-3">
            <img
              class="img-thumbnail"
              width="200"
              height="200"
              alt="posible fotografía del paciente"
              :src="
                'https://avanti-erp.com/' +
                informacionPaciente.datos[0].url_foto
              "
            />
            <br />
            <br />
            <br />
            <center>
              <h4
                style="color: green"
                v-if="informacionPaciente.datos[0].estado == 1"
              >
                ACTIVO
              </h4>
              <h4 style="color: red" v-else>INACTIVO</h4>
            </center>
          </div>
          <div class="col-md-9">
            <div class="row">
              <div class="col-md-12">
                <center><span>Datos Personales</span></center>
                <br />
              </div>
              <div class="col-md-6">
                <small for="">Nombres</small>
                <input
                  type="text"
                  class="form-control"
                  readonly
                  :value="informacionPaciente.datos[0].PacNom1"
                />
              </div>
              <div class="col-md-6">
                <small for="">Apellidos</small>
                <input
                  type="text"
                  class="form-control"
                  readonly
                  :value="informacionPaciente.datos[0].PacApe1"
                />
              </div>
              <div class="col-md-6">
                <small for="">Fecha de nacimiento</small>
                <input
                  type="text"
                  class="form-control"
                  readonly
                  :value="informacionPaciente.datos[0].PacFecNac"
                />
              </div>
              <div class="col-md-6">
                <small for="">Fehca de ingreso</small>
                <input
                  type="text"
                  class="form-control"
                  readonly
                  :value="informacionPaciente.datos[0].PacFecIng"
                />
              </div>
            </div>
            <div class="row">
              <br />
              <div class="col-md-12">
                <center><span>Datos de afiliación</span></center>
                <br />
              </div>

              <div class="col-md-6">
                <small>Eps</small>
                <input
                  type="text"
                  class="form-control"
                  :value="informacionPaciente.eps"
                  readonly
                />
              </div>
              <div class="col-md-6">
                <small>Prepagada</small>
                <input
                  type="text"
                  class="form-control"
                  :value="informacionPaciente.prepagada"
                  readonly
                />
              </div>
              <div class="col-md-6">
                <small>Póliza</small>
                <input
                  type="text"
                  class="form-control"
                  :value="informacionPaciente.poliza"
                  readonly
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="modal-body">
        <center>
          <h4>
            <i class="fa fa-spinner"></i> Actualizando información del
            paciente...
          </h4>
        </center>
      </div>
    </modal>
  </div>
</template>
<script>
import Vue from "vue";
import Switches from "vue-switches";
import rockerswitch from "vue-rocker-switch";
import "vue-rocker-switch/dist/vue-rocker-switch.css";

import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
import axios from "axios";
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
export default {
  computed: {
    pagedData() {
      return this.pacientes.slice(this.from, this.to);
    },
    /*
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    queriedData() {
      if (!this.searchQuery) {
        this.pagination.total = this.pacientes.length;
        return this.pagedData;
      }
      let result = this.pacientes.filter((row) => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString().toLowerCase();
          if (
            rowValue.includes &&
            rowValue.includes(this.searchQuery.toLowerCase())
          ) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      this.pagination.total = this.pacientes.length;
      return this.pacientes.length;
    },
  },
  data() {
    return {
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100, 200, 300],
        total: 0,
      },
      searchQuery: "",
      ver: 1,
      propsToSearch: [
        "PacNom1",
        "PacApe1",
        "PacNumDoc",
        "PacFecNac",
        "PacFecIng",
      ], //NOMBRE DE LOS CAMPOS POR LOS QUE DESEAS BUSCAR
      tableColumns: [
        {
          prop: "PacNom1", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
          label: "Nombres", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
          minWidth: 150, //ANCHO DE LA COLUMNA
        },
        {
          prop: "PacApe1", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
          label: "Apellidos", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
          minWidth: 150, //ANCHO DE LA COLUMNA
        },
        {
          prop: "PacNumDoc",
          label: "Número de documento",
          minWidth: 150,
        },
        {
          prop: "PacFecNac",
          label: "Fecha de nacimiento",
          minWidth: 150,
        },
        {
          prop: "PacFecIng",
          label: "Fecha de ingreso",
          minWidth: 120,
        },
      ],
      ip: "https://avanti-erp.com",
      pacientes: [], //NOMBRE DEL ARRAY EN EL QUE VAS A ALMACENAR LOS DATOS
      //POR EJEMPLO pacientes: [] solo aquí es donde lo declaras
      PacIde: 0,
      informacionPaciente: [],
      rol: '',

      // estadisticas
      pacientesActivos: 0,
      pacientesInactivos: 0,
      totalPacientes: 0,
      fisio: "",
      fono: "",
      teo: "",
      edu: "",
      psico: "",
      block: false,
      terapeutasFisio: [],
      terapeutasTeo: [],
      terapeutasFono: [],
      terapeutasPsico: [],
      terapeutasEdu: [],
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false,
      },
      json_fields: {
      "Nombres del paciente": "paciente",
      "Numero documento" : "documento",
      "Fecha nacimiento" : 'fecha_nacimiento',
      "Fecha ingreso" : "fecha_ingreso",
      "Lider Fisioterapia" : "terapeutaFisio",
      "Lider Fonoaudiología" : "terapeutaFono",
      "Lider Psicología" : "terapeutaPsico",
      "Lider Terapia ocupacional" : "terapeutaTeo",
      "Lider Educación Especial" : "terapeutaEdu",
      "estado" : "estado"
    },
    json_data: [],
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8",
        },
      ],
    ],
    };
  },
  components: {
    Switches,
    rockerswitch,
    PPagination,
  },
  methods: {
    actualizarEstado(id, estado) {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const BASE_URL = `${this.ip}/api/actualizarEstado`;
      axios
        .put(
          BASE_URL,
          {
            id: id,
            estado: estado,
          },
          config
        )
        .then((res) => {
          console.log(res.data);
          alert("Estado del usuario actualizado con éxito");
          this.cargarPacientes()
        })
        .catch((err) => {
          console.log(err);
          alert("Error en el servidor, intentelo de nuevo");
        });
    },
    modal(index, paciente) {
      this.$modal.show("buscar");
      this.PacIde = paciente.PacIdeUsu;
      this.fisio = paciente.t_fisio;
      this.fono = paciente.t_fono;
      this.teo = paciente.t_teo;
      this.psico = paciente.t_psico;
      this.edu = paciente.t_edu;
      this.block = paciente.PacBlo;
    },
    modalDetallePaciente(paciente) {
      this.informacionPaciente = [];
      this.$modal.show("modalDetallePaciente");
      var token = localStorage.getItem("token");
      axios
        .request({
          method: "get",
          baseURL: this.ip + "/api/pacienteHC/" + paciente.PacIdeUsu,
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.informacionPaciente = response.data.data;
          console.log(this.informacionPaciente, "datos");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    cerrar_modal(index, paciente) {
      this.$modal.hide("buscar");
      this.PacIde = "";
    },
    t_fisio: function () {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const rol = localStorage.getItem('rol');
      let sede = 'todas';
      if( rol > 1 ){
        sede = localStorage.getItem('sede')
      }
      let url = this.ip + "/api/terapeutas/2/" + sede;
      axios
        .get(url, config)
        .then((response) => {
          this.terapeutasFisio = response.data.data;
        })
        .catch((error) => {
          console.log();
        });
    },
    t_teo: function () {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const rol = localStorage.getItem('rol');
      let sede = 'todas';
      if( rol > 1 ){
        sede = localStorage.getItem('sede')
      }
      let url = this.ip + "/api/terapeutas/4/" + sede;
      axios
        .get(url, config)
        .then((response) => {
          this.terapeutasTeo = response.data.data;
        })
        .catch((error) => {
          console.log();
        });
    },
    t_fono: function () {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const rol = localStorage.getItem('rol');
      let sede = 'todas';
      if( rol > 1 ){
        sede = localStorage.getItem('sede')
      }
      let url = this.ip + "/api/terapeutas/3/" + sede;
      axios
        .get(url, config)
        .then((response) => {
          this.terapeutasFono = response.data.data;
        })
        .catch((error) => {
          console.log();
        });
    },
    t_psico: function () {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const rol = localStorage.getItem('rol');
      let sede = 'todas';
      if( rol > 1 ){
        sede = localStorage.getItem('sede')
      }
      let url = this.ip + "/api/terapeutas/6/" + sede;
      axios
        .get(url, config)
        .then((response) => {
          this.terapeutasPsico = response.data.data;
        })
        .catch((error) => {
          console.log();
        });
    },
    t_edu: function () {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const rol = localStorage.getItem('rol');
      let sede = 'todas';
      if( rol > 1 ){
        sede = localStorage.getItem('sede')
      }
      let url = this.ip + "/api/terapeutas/5/" + sede;
      axios
        .get(url, config)
        .then((response) => {
          this.terapeutasEdu = response.data.data;
        })
        .catch((error) => {
          console.log();
        });
    },
    asignar_lideres() {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      let url = this.ip + "/api/asignarLideres";
      axios
        .put(
          url,
          {
            paciente: this.PacIde,
            lider_fisio: this.fisio,
            lider_fono: this.fono,
            lider_teo: this.teo,
            lider_psi: this.psico,
            lider_edu: this.edu,
            block: this.block,
          },
          config
        )
        .then((response) => {
          this.$modal.hide("buscar");
          var color = Math.floor(Math.random() * 4 + 1);
          this.$notify({
            component: {
              template: `<span><b>Lideres actualizados con éxito!</b>.</span>`,
            },
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: this.type[color],
          });
          this.cargarPacientes()
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleEdit(index, row) {
      alert(`Your want to edit ${row.name}`);
    },
    handleDelete(index, row) {
      let indexToDelete = this.pacientes.findIndex(
        (tableRow) => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.pacientes.splice(indexToDelete, 1);
      }
    },
    valueWithState(arr, state) {
      let acu = 0;
      for (let index = 0; index < arr.length; index++) {
        if (arr[index].estado == state) {
          acu = acu + 1;
        }
      }
      return acu;
    },
    cargarPacientes() {
      this.json_data = [];
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      
      const rol = localStorage.getItem('rol');
      let sede = 'todas';
      if( rol > 1 ){
        sede = localStorage.getItem('sede')
      }
      var url = this.ip + "/api/allPacientes/" + this.ver + "/" + sede;

      axios
        .get(url, config)
        .then((response) => {
          let datos = [];
          this.pacientes = response.data.data;
          this.pacientesActivos = this.valueWithState(
            response.data.estadistica,
            1
          );
          this.pacientesInactivos = this.valueWithState(
            response.data.estadistica,
            0
          );
          this.totalPacientes = response.data.estadistica.length;

          for (let index = 0; index < response.data.data.length; index++) {
            let estado = '';

            if(response.data.data[index].estado==1){
              estado = 'Activo'
            }else{
              estado = 'Inactivo'
            }
           
            datos.push({
              paciente: response.data.data[index].PacApe1+ ' ' + response.data.data[index].PacNom1,
              documento : response.data.data[index].PacNumDoc,
              fecha_nacimiento : response.data.data[index].PacFecNac,
              fecha_ingreso : response.data.data[index].PacFecIng,
              estado: estado,
              terapeutaFisio: response.data.data[index].t_fisio,
              terapeutaFono: response.data.data[index].t_fono,
              terapeutaTeo: response.data.data[index].t_teo,
              terapeutaPsico : response.data.data[index].t_psico,
              terapeutaEdu: response.data.data[index].t_edu
            })
            
          }

          this.json_data = datos;
          // console.log('datos excel', datos);
          
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  mounted() {
    if (!localStorage.getItem("token")) {
      this.$router.push("/");
    } else {
      this.cargarPacientes();
      this.t_fisio();
      this.t_fono();
      this.t_psico();
      this.t_edu();
      this.t_teo();
      this.rol = localStorage.getItem("rol")
    }
  },
};

//NOTA: TODOS LOS CAMPOS EN LOS QUE VEAS QUE DICE pacientes, VAS A COLOCAR EL NOMBRE
//CON EL QUE DEFINISTE TU ARRAY.
</script>
<style scoped>
.texto-pequeno {
  font-size: 12px;
  color: darkgray;
  padding: 0px !important;
  margin: 0px !important;
}
.fa-users {
  font-size: 37px !important;
}

.form-control {
  background-color: white !important;
}

.fa-user {
  font-size: 60px;
}
</style>


// WEBPACK FOOTER //
// src/components/Admisiones/pacientes-registrados.vue